"use strict";

import store from "../store";
import io from "socket.io-client";

const state = {
  $io: null
};

const register = $io => {
  const socketMutations = Object.keys(store._mutations).filter(k =>
    /^SOCKET_/.test(k)
  );
  for (const socketMutation of socketMutations) {
    $io.on(socketMutation.replace("SOCKET_", "").toLowerCase(), message => {
      store.commit(socketMutation, message);
    });
  }
};

const mutations = {
  connect(state, user) {
    if (state.$io == null) {
      const SOCKET_IO_URL = store.state.config.socketIoURL;
      state.$io = io(
        `${SOCKET_IO_URL}roles-${user.roles[0]}/${user.company._id}`,
        {
          query: `auth_token=${user.accessToken}&bot-party=${store.state.config.party}`,
          forceNew: true
        }
      );

      register(state.$io);

      // eslint-disable-next-line
      state.$io.on("disconnect", reason => {
        state.$io = null;
      });

      // eslint-disable-next-line
      const query = state.$io.query
        .split("&")
        // eslint-disable-next-line
        .reduce(function(prev, curr, i, arr) {
          var p = curr.split("=");
          prev[decodeURIComponent(p[0])] = decodeURIComponent(p[1]);
          return prev;
        }, {});
    }
  },
  disconnect(state) {
    if (state.$io != null && state.$io.connected) {
      state.$io.close();
    }
  }
};

const actions = {};

export default {
  state,
  mutations,
  actions
};
